import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NewsfeedContentSource } from '@planone/bau365/data-access-newsfeed';
import { Channel, selectChannelId } from '@planone/bau365/data-access-user';

@Component({
  selector: 'bau365-channel-group',
  templateUrl: './channel-group.component.html',
  styleUrls: ['./channel-group.component.scss'],
})
export class ChannelGroupComponent {
  @Input() name = '';
  @Input() channels: Channel[] | undefined | null = [];
  @Input() source: NewsfeedContentSource | undefined | null;
  @Input() addChannelsLink: string | undefined | null;
  @Input() addChannelsText: string | undefined | null;
  @Input() threshold = 7;

  @Output() selectChannel = new EventEmitter<Channel>();

  expand = true;
  get expandMore(): string {
    return $localize`:@@featureNewsfeed-channelsGroup-showMore:${
      (this.channels?.length ?? 0) - this.threshold
    } weitere anzeigen`;
  }
  expandLess = $localize`:@@featureNewsfeed-channelsGroup-showLess:weniger anzeigen`;

  onSelectChannel(channel: Channel): void {
    this.selectChannel.emit(channel);
  }

  identifyChannel(_index: number, channel: Channel) {
    return selectChannelId(channel);
  }
}
